import {getSystem} from './site'
/**
 * @returns {
 * 	effect: act | shop,
 *  platform: pc | mob
 * }
 */
export function getPlatform(){
	var platform
	var effect
	if(window.pageConfig&&window.pageConfig.platform){
		platform=window.pageConfig.platform
	}else{
		platform=location.pathname.split('/')[2]
	}
	if(window.pageConfig&&window.pageConfig.effect){
		effect=window.pageConfig.effect
	}else{
		effect=location.pathname.split('/')[1]
	}
	return {
		platform,
		effect
	}
}

/**
 * @returns pc | mob | app
 */
export function getTerminal(){
	if(isApp()){
		return 'app'
	}
	let {platform}=getPlatform()
	return platform
}

export function isApp(){
	var appType=getAppType()
	if(appType==getSystem()){
		return true
	}
	if(/^\/app\//.test(location.pathname)){
		return true
	}
	return false
}

export function getAppType(){
	var UA = navigator.userAgent
	if(UA.indexOf("eptApp") > -1){
		return 'ept'
	}
	if(UA.indexOf("THApp") > -1){
		return 'th'
	}
	if(UA.indexOf('jdzgbapp')>-1){
		return 'EJSHOP'
	}
	if(UA.indexOf("jdapp") > -1){
		return 'cn'
	}
	return null
}

export function isEditorPage(){
	return location.pathname.includes("editor")
}